import { render, staticRenderFns } from "./duoxuan.vue?vue&type=template&id=a4113fae&"
import script from "./duoxuan.vue?vue&type=script&lang=ts&"
export * from "./duoxuan.vue?vue&type=script&lang=ts&"
import style0 from "./duoxuan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports